import { ofType } from "redux-observable";
import { map } from "rxjs/operators";
import { actionGameTrackingUpdateShop } from "../../actionGameTracking";
import { TypeActionGameTrackingShopOpenSource, } from "../actionGameTrackingShop";
import { IdGameTrackingShopState } from "../IdGameTrackingShopState";
export var epicGameTrackingShopProviderSelect = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionGameTrackingShopOpenSource.ProviderSelect), map(function (action) {
        return actionGameTrackingUpdateShop(IdGameTrackingShopState.PROVIDER_SELECT, action.providerId);
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/game-tracking/shop/epics/epicGameTrackingShopProviderSelect.ts
// module id = 1883
// module chunks = 3